import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { useAuth } from "../lib/auth";

export const LoginDialog = ({ open, onOpenChange }) => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const u = await login(email, password);
      toast.success(`Welcome, ${u.name}`);
      setPassword("");
      onOpenChange(false);
    } catch (err) {
      setError(err.response?.data?.detail?.toString() || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="login-dialog" className="border-[color:var(--border)] bg-[color:var(--surface)] sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display text-2xl"><Lock className="h-5 w-5 text-amber-400" /> Supervisor Login</DialogTitle>
          <DialogDescription>Log in to edit teams, jobs, assignments and daily logs.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label className="label">Email</Label>
            <Input data-testid="login-email-input" type="email" required autoFocus value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" />
          </div>
          <div className="space-y-1.5">
            <Label className="label">Password</Label>
            <Input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-red-400">{error}</p>}
          <Button data-testid="login-submit-button" type="submit" disabled={busy} className="w-full bg-amber-500 text-black hover:bg-amber-400">
            {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Log in
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
